var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-dialog.ts
import { ElementsDialog } from "@adornis/dialog/x-dialog";
import "@adornis/dialog/x-plain-dialog";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import "./ge-button";
import "./ge-input";
var GermaniumDialog = class extends ElementsDialog {
  static get element_name() {
    return "ge-dialog";
  }
  getInnerWrapper(options) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty("background", this.colors.light);
    wrapperElem.style.setProperty("border-radius", this.sizes.borderRadius);
    return wrapperElem;
  }
  getContentWrapper(options) {
    const wrapperElem = super.getContentWrapper(options);
    if (!options.draggable)
      wrapperElem.style.removeProperty("height");
    return wrapperElem;
  }
  static confirm(text, confirmOptions = {
    highlightDecline: false
  }) {
    return this.showPopup({
      content: (resolve) => html`
        <x-flex space="md" padding="md">
          <ge-text>${text}</ge-text>
          <x-flex horizontal end space="md">
            <ge-button
              mode="${confirmOptions.highlightDecline ? "action" : "outline"}"
              @click="${() => resolve(false)}"
            >
              <ge-text> Nein </ge-text>
            </ge-button>
            <ge-button mode="${confirmOptions.highlightDecline ? "outline" : "action"}" @click="${() => resolve(true)}">
              <ge-text> Ja </ge-text>
            </ge-button>
          </x-flex>
        </x-flex>
      `
    });
  }
  static alert(text) {
    return this.showPopup({
      content: (resolve) => html`
        <x-flex space="md" padding="md">
          ${typeof text === "string" ? html`<ge-text>${text}</ge-text>` : text}
          <x-flex horizontal end space="md">
            <ge-button @click="${() => resolve()}"> <ge-text> Ok </ge-text> </ge-button>
          </x-flex>
        </x-flex>
      `
    });
  }
  static prompt(text) {
    return this.showPopup({
      content: (resolve) => {
        let response = "";
        return html`
          <x-flex space="md" padding="md">
            <ge-text>${text}</ge-text>
            <ge-input @value-changed=${(e) => response = e.detail.value}></ge-input>
            <x-flex horizontal end space="md">
              <ge-button @click=${() => resolve(response)}> <ge-text> Ok </ge-text> </ge-button>
            </x-flex>
          </x-flex>
        `;
      }
    });
  }
};
GermaniumDialog = __decorateClass([
  customElement("ge-dialog")
], GermaniumDialog);
export {
  GermaniumDialog as default
};
